import { render } from "./Contact.vue?vue&type=template&id=404864e8&scoped=true&ts=true"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"

import "./Contact.vue?vue&type=style&index=0&id=404864e8&lang=scss&scoped=true"

import exportComponent from "/Users/iti/Documents/icandy_website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404864e8"]])

export default __exports__